// Formattazione delle Statistiche (Google Analytics); il resto arriva dalla dashboard vendite
export { formatNumber, formatPct, formatDelta, deltaColor, bucketLabel } from '@/components/dashboard/format';

// 155 -> "2m 35s", 42 -> "42s", 3725 -> "1h 2m"
export const formatDurata = secondi => {
	const s = Math.round(+secondi || 0);
	if (s < 60) return `${s}s`;
	const h = Math.floor(s / 3600);
	const m = Math.floor((s % 3600) / 60);
	if (h > 0) return `${h}h ${m}m`;
	return `${m}m ${String(s % 60).padStart(2, '0')}s`;
};

export const formatDecimale = (valore, cifre = 1) => (+valore || 0).toLocaleString('it-IT', { minimumFractionDigits: cifre, maximumFractionDigits: cifre });

let nomiPaesi = null;
// Nome del paese in italiano dal codice ISO (GA restituisce il nome in inglese)
export const nomePaese = (codice, ripiego = '') => {
	if (!codice || codice === '(not set)') return 'Non rilevato';
	try {
		if (!nomiPaesi) nomiPaesi = new Intl.DisplayNames(['it'], { type: 'region' });
		return nomiPaesi.of(codice) || ripiego || codice;
	} catch (e) {
		return ripiego || codice;
	}
};

export const bandiera = codice => {
	try {
		return require(`@/assets/images/flag/${codice}.svg`);
	} catch (e) {
		return require('@/assets/images/flag/map.svg');
	}
};
